import styles from './devicesTabPage.module.css';

import addIcon from 'assets/svg/add-01.svg';

import { observer } from 'mobx-react-lite';
import { useCallback, useContext, useEffect, useRef } from 'react';
import ActionButton from 'ui/ActionButton';
import Table, { TableToolbarButtons } from 'widgets/Table';
import { storageStore } from 'store/mobx/storage.store';
import { treeStore } from 'store/mobx/tree.store';
import { modalStore } from 'store/mobx/modal.store';
import { STORAGE_TYPE } from 'consts/storage.consts';
import { Store } from 'store/context/Store';
import { ChildrenSampleStore } from 'store/context/ChildrenSampleStore';
import { SampleSourceStore } from 'store/context/SampleSourceStore';
import { socketStore } from 'store/mobx/socket.store';

const TableSamples = observer((props) => {
  const { mode } = props;
  const tableRef = useRef(null);
  const storeContext = useContext(Store);
  const { setSelectedTreeSample } = useContext(ChildrenSampleStore);
  const sampleSourceStore = useContext(SampleSourceStore);
  const { loadSampleById } = storeContext;
  const { selectedNode } = treeStore;
  const { samples, getSamples, pagination, columns, setSelectedSampleArrayForCopy, setSensors } =
    storageStore;

  useEffect(() => {
    if (selectedNode?.devices?.filter((i) => !isNaN(i.id_sensor))?.length > 0) {
      const unsub = socketStore.subscribe(
        'sensors',
        [...selectedNode?.devices?.filter((i) => !isNaN(i.id_sensor))?.map((i) => i.id_sensor)],
        (msg) => {
          setSensors(msg);
        },
      );

      return () => {
        setSensors([]);
        unsub();
      };
    }

    return () => {
      setSensors([]);
    };
  }, [selectedNode]);

  useEffect(() => {
    return () => {
      setSelectedSampleArrayForCopy([]);
      modalStore.closeAllModals();
    };
  }, []);

  useEffect(() => {
    if (!tableRef.current) return;

    const unsubscribe = tableRef.current.subscribe((rows) => {
      setSelectedSampleArrayForCopy(rows?.map((i) => i.id));
    });

    return () => unsubscribe();
  }, []);

  const addNewDevice = useCallback(() => {
    modalStore.openModal(
      'sampleType',
      { storageId: selectedNode.id, mode, type: STORAGE_TYPE.table },
      true,
    );
  }, []);

  const onTableUpdate = async (options) => {
    await getSamples({ ...options, id: selectedNode.id, type: selectedNode.entity });
  };

  const onLoadSample = async (id) => {
    await loadSampleById(id);
  };

  return (
    <Table
      initialColumns={columns}
      initialRows={samples}
      totalItems={pagination.itemsCount}
      itemsPerPage={pagination.limit}
      page={pagination.page}
      ref={tableRef}
      onUpdate={onTableUpdate}
      onRowClick={async (row) => {
        await onLoadSample(row.id);
        modalStore.openModal(
          'sampleView',
          {
            mode,
            setSelectedTreeSample,
            storeContext,
            sampleSourceStore,
          },
          true,
        );
      }}
      isSelectable
      isExpandable
    >
      <TableToolbarButtons>
        <ActionButton
          icon={addIcon}
          styleConfig={{
            container: styles.toolbarActionButtonContainer,
            iconContainer: styles.toolbarActionButton,
            tooltipText: 'Добавить',
          }}
          color="#fff"
          onClick={addNewDevice}
        />
      </TableToolbarButtons>
    </Table>
  );
});

export default TableSamples;
